module.exports = __webpack_public_path__ + "img/archivador.4310f220.png";